import { faCaretDown } from "@fortawesome/pro-solid-svg-icons/faCaretDown";
import { faReply } from "@fortawesome/pro-solid-svg-icons/faReply";
import { faThumbsDown } from "@fortawesome/pro-solid-svg-icons/faThumbsDown";
import { faThumbsUp } from "@fortawesome/pro-solid-svg-icons/faThumbsUp";
import { faTimes } from "@fortawesome/pro-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert } from "@mui/lab";
import { Avatar, Divider, Grid, Menu, MenuItem, Theme, Toolbar, Typography } from '@mui/material';
import { createStyles, withStyles, WithStyles } from "@mui/styles";
import * as api from "api/Knowledge";
import { GlobalClassKeys } from 'assets/jss/common-styles';
import AdvFilter, { advFilterAddCommand, AdvFilterCommand, AdvFilterPicker, AdvFilterResult } from 'components/AdvFilter';
import ButtonCancel from 'components/Buttons/ButtonCancel';
import IconButtonFilter from 'components/Buttons/IconButtonFilter';
import IconButtonOverflowV from 'components/Buttons/IconButtonOverflowH';
import { SpinnerIndicator } from 'components/CallServer';
import RequestErrorDialog from "components/CallServer/RequestErrorDialog";
import { RequestErrorReport } from "components/CallServer/RequestErrorReport";
import IconThumbUp from 'components/Icons/IconThumbUp';
import MuiRegularButton from 'components/MuiExtras/Button/MuiRegularButton';
import { MuiFilterAppBar } from 'components/MuiExtras/Filter';
import MuiConfirmation from "components/MuiExtras/MuiConfirmation";
import MuiContainer from 'components/MuiExtras/MuiContainer';
import MuiColor from 'components/MuiExtras/Typography/MuiColor';
import MuiDanger from 'components/MuiExtras/Typography/MuiDanger';
import MuiMuted from 'components/MuiExtras/Typography/MuiMuted';
import { withSnackbar, WithSnackbar } from "components/SnackbarProvider/Snackbar";
import TextFieldCounter from 'components/TextFieldCounter';
import UserFullProfileLink from 'components/UserFullProfileLink';
import { UsernameResolver } from "components/UsernameInspect";
import { Formaters } from 'lib/Formarters';
import HtmlUtils from 'lib/HtmlUtils';
import LibUtils, { nprop } from "lib/LibUtils";
import { PublicationLikeOption } from 'models/ApiEnums';
import { CommentListItemDto, CommentListOrderBy, DeleteCommentResult, GetCommentListParams } from 'models/ApiModels';
import { RequestLifeCycle } from "models/AppModels";
import * as moment from "moment";
import queryString from 'query-string';
import * as React from 'react';
import { Fragment } from 'react';
import { WithTranslation, withTranslation } from "react-i18next";
import { RoutePaths } from 'routes/RouteConfig';
import Session from 'services/Session';
import AbuseReportCommentDrawer from "views/Timeline/Dialogs/AbuseReportCommentDrawer";

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const styles = (theme: Theme) => createStyles({

    leftMargin: {
        marginLeft: "auto"
    },
    rightMargin: {
        marginRight: "auto"
    },
    containerOuter: {
        width: "auto",
        display: "flex",
        flexWrap: "wrap",
    },
    containerInner: {
        width: "100%",
        position: "relative",
        paddingLeft: "15px",
        paddingRight: "15px",
        minHeight: "150px"
    },
    itemOuter: {
        display: "flex",
        alignItems: "flex-start",
        marginTop: "10px"

    },
    itemPicture: {
        margin: "0 auto",
        overflow: "hidden",
        boxShadow: "0 6px 10px 0 rgba(0, 0, 0, 0.14), 0 1px 18px 0 rgba(0, 0, 0, 0.12), 0 3px 5px -1px rgba(0, 0, 0, 0.2)",
        marginRight: "15px",
        borderRadius: "50%",
        "& img": {
            width: "48px",
            height: "48px",
        }
    },
    itemContent: {
        flex: 1,
    },
    itemFooter: {
        marginBottom: "8px",
        display: "block"
    },

    itemEditButtons: {
        textAlign: "right"
    },

    filtered: {
        color: theme.genie.palette.warning.main,
        display: "inline-block"
    },

    highlightComment: {
        backgroundColor: theme.genie.palette.warning.dark,
    },

    itemSeparator: {
        borderBottomColor: theme.palette.common.black,
        borderBottomStyle: "dotted",
        borderBottomWidth: 1

    }
});

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

const CmdComments = "my";
const CmdAuthor = "author";
const CmdStartDate = "startDate";
const CmdEndDate = "endDate";

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

interface IState {
    advFilters: AdvFilterResult[];

    orderByMenuAnchorEl: any;
    commentMenuAnchorEl: any;
    commentActionMenu: Array<any>;

    formCycle: RequestLifeCycle;
    responding: boolean;
    lastError: any;

    inAdvFilter: boolean;
    orderBy: CommentListOrderBy;
    filter: Filter;

    newCommentText: string;
    commentToDelete: CommentListItemDto;
    reportingAbuse: CommentListItemDto;
    comments: CommentListItemDto[];
    totalRecords: number;
    totalThreads: number;
    readOnly: boolean;
}

interface IProps {
    publicationId: string;
    startDate?: Date;
    endDate?: Date;
    autoFocus?: boolean;
    overModal?: boolean;
    onUpdateCommentCounter?: (totalComments: number) => void;
}

type Props = IProps & WithStyles<typeof styles> & WithSnackbar & WithTranslation;

type Filter = {
    searchText: string;
    findCommentId?: string;
    authors: string[];
    startDate: Date;
    endDate: Date;
};

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////

class CommentBox extends React.Component<Props, IState> {
    private referenceDate: Date;
    private hightlightCommentId: string;
    private loadCount = 0;
    private actionId: string = null;

    constructor(props: Props) {
        super(props);
        this.state = {
            advFilters: [],
            filter: null,
            orderBy: CommentListOrderBy.PublishDate,

            orderByMenuAnchorEl: null,
            commentMenuAnchorEl: null,
            commentActionMenu: null,

            inAdvFilter: false,
            formCycle: RequestLifeCycle.None,
            responding: false,
            lastError: null,

            newCommentText: "",
            commentToDelete: null,
            reportingAbuse: null,
            comments: [],
            totalRecords: 0,
            totalThreads: 0,
            readOnly: true,
        };

        const q = queryString.parse(document.location.search);
        this.hightlightCommentId = (q["pcmid"] as string) || null;
    }

    ///
    private get commands(): AdvFilterCommand[] {
        return [
            { keyword: CmdComments, displayName: this.props.t("Views.Publication.Components.CommentBox.CmdComments"), picker: null },
            { keyword: CmdAuthor, displayName: this.props.t("Views.Publication.Components.CommentBox.CmdAuthor"), picker: AdvFilterPicker.User, canRepeat: true },
            { keyword: CmdStartDate, displayName: this.props.t("Views.Publication.Components.CommentBox.CmdStartDate"), picker: AdvFilterPicker.Calendar },
            { keyword: CmdEndDate, displayName: this.props.t("Views.Publication.Components.CommentBox.CmdEndDate"), picker: AdvFilterPicker.Calendar }
        ];
    }

    ///
    private resetState(): Partial<IState> {
        return {
            filter: null,
            inAdvFilter: false,
            formCycle: RequestLifeCycle.None,
            responding: false,
            reportingAbuse: null,
            commentMenuAnchorEl: null,
            orderByMenuAnchorEl: null,
            newCommentText: "",
            commentToDelete: null
        };
    }

    ///
    private getCurrentOrderByName(): string {
        switch (this.state.orderBy) {
            case CommentListOrderBy.Best: return this.props.t("Common.Filter.Toolbar.OrderBy.MostLiked");
            case CommentListOrderBy.PublishDate: return this.props.t("Common.Filter.Toolbar.OrderBy.MostRecent");
        }
        return "";
    }

    ///
    private appendComments(commentId: string, appendValues: CommentListItemDto[]) {

        if (commentId == null)
            return this.state.comments.concat(appendValues);

        // Os comentários de segundo nível devem ser no final da lista pois estão ordenados por ordem de data (crescente).
        const currentList = this.state.comments;
        const index = currentList.length + 1 - currentList.slice().reverse().findIndex(p => p.parentId == commentId);
        if (index > -1) {
            const list = ([] as CommentListItemDto[]).concat(currentList.slice(0, index), appendValues, currentList.slice(index));

            const comment = list.find(p => p.commentId == commentId);
            comment.loading = false;
            comment.responding = false;
            return list;
        }

        return this.state.comments;
    }

    ///
    private insertPostComment(commentId: string, replyCommentId: string, appendValues: CommentListItemDto) {

        if (commentId == null)
            return [appendValues].concat(this.state.comments);

        const currentList = this.state.comments;
        let newList = ([] as CommentListItemDto[]);

        var comment = currentList.find(p => p.commentId == commentId);
        if (comment != null) {
            comment.answers++;
            comment.responding = false;

            if (replyCommentId != null) {
                // Tréplicas devem ser inseridas abaixo do comentário replicado.
                const index = currentList.findIndex(p => p.parentId == commentId && p.commentId == replyCommentId) + 1;
                newList = newList.concat(currentList.slice(0, index), [appendValues], currentList.slice(index));

                var reply = newList.find(p => p.commentId == replyCommentId);
                reply.responding = false;
            }
            else {
                // Réplicas devem ser inseridas no topo da lista de segundo nível
                const index = currentList.findIndex(p => p.commentId == commentId) + 1;
                newList = newList.concat(currentList.slice(0, index), [appendValues], this.state.comments.slice(index));
            }
        }

        return newList;
    }

    ///
    private updateComment(commentId: string, data: Partial<CommentListItemDto>) {
        // clone comments
        var newComments = this.state.comments.slice(0);

        // update comment
        var comment = newComments.find(p => p.commentId == commentId);
        if (comment != null) Object.assign(comment, data);

        return newComments;
    }

    ///
    private get showingAllRecords(): boolean {
        return LibUtils.isAllPropertiesWithValue(this.state.filter, null);
    }

    ///
    private reload() {
        this.referenceDate = moment.utc().toDate();
        this.loadComments(null, 0, true);
    }

    ///
    private loadComments(commentId: string, lastIndex: number, clearList: boolean = false) {
        this.loadCount++;

        var newState: Partial<IState> = { orderByMenuAnchorEl: null, commentActionMenu: null };

        newState.inAdvFilter = false;

        if (commentId != null)
            newState.comments = this.updateComment(commentId, { loading: true });
        else {
            if (clearList === true) {
                newState.comments = [];
                newState.totalRecords = 0;
                newState.totalThreads = 0;
            }
            newState.formCycle = RequestLifeCycle.Loading;
        }

        this.setState({ ...this.state, ...newState });
        const f = nprop(this.state.filter);

        const p: GetCommentListParams = {
            publicationId: this.props.publicationId,
            commentId: commentId,
            lastIndex: lastIndex,
            referenceDate: this.referenceDate,
            take: 3,
            orderBy: this.state.orderBy,

            searchText: nprop(f.searchText, null),
            startDate: nprop(f.startDate, null),
            endDate: nprop(f.endDate, null),
            authors: nprop(f.authors, null),

            findCommentId: this.loadCount == 1 ? this.hightlightCommentId : null
        };

        console.log(p);
        api.getComments(p)
            .then((result) => {
                var newData: Partial<IState> = {
                    comments: this.appendComments(commentId, result.comments)
                };
                if (commentId == null) {
                    newData.totalRecords = result.totalRecords;
                    newData.totalThreads = result.totalThreads;
                }

                console.log(result);

                this.setState({ ...this.state, ...newData, readOnly: result.readOnly, formCycle: RequestLifeCycle.None });
            })
            .catch((error) => {
                this.setState({ comments: [], lastError: error, formCycle: RequestLifeCycle.LoadFailed });
            });
    }

    ///
    private postNewComment(publicationId: string, parentId: string, replyCommentId: string, message: string) {
        api.postComment({ publicationId, parentId, replyCommentId, message, publisherId: Session.user.id })
            .then((v) => {
                this.setState(
                    {
                        ...this.state,
                        ...this.resetState(),
                        ...{ comments: this.insertPostComment(parentId, replyCommentId, v.comment) },
                        ...{ totalRecords: v.totalComments },
                        ...{ totalThreads: parentId == null ? this.state.totalThreads + 1 : this.state.totalThreads }
                    });
                if (this.props.onUpdateCommentCounter) this.props.onUpdateCommentCounter(v.totalComments);

                this.props.snackbar.showMessage(this.props.t("Views.Publication.Components.CommentBox.PostCommentSuccess"), "success");
            })
            .catch((error) => {
                this.setState({ lastError: error, formCycle: RequestLifeCycle.PostFailed });
            });
    }

    ///
    private postUpdateComment(commentId: string, message: string) {
        api.updateComment(commentId, message)
            .then(() => {
                this.setState(
                    {
                        ...this.state,
                        ...this.resetState(),
                        ...{ comments: this.updateComment(commentId, { message, lastUpdateDate: new Date(), editing: false }) }
                    });
                this.props.snackbar.showMessage(this.props.t("Views.Publication.Components.CommentBox.UpdateCommentSuccess"), "success");
            })
            .catch((error) => {
                this.setState({ lastError: error, formCycle: RequestLifeCycle.PostFailed });
            });
        ;
    }

    ///
    private recalculateStateAfterDelete(data: DeleteCommentResult) {
        // clone comments
        var newComments = this.state.comments.slice(0);
        var totalThreads = this.state.totalThreads;

        data.deletedComments?.forEach((item) => {
            var reply = newComments.find(p => p.commentId == item.replyCommentId);
            var parent = newComments.find(p => p.commentId == item.parentId);

            if (reply != null) reply.answers--;
            if (parent != null) parent.answers--;
            if (item.parentId == null) totalThreads--;

            newComments = newComments.filter(p => p.commentId != item.commentId);
        });

        data.changedComments?.forEach((item) => {
            // update comment
            var comment = newComments.find(p => p.commentId == item.commentId);
            if (comment != null) Object.assign(comment, item);
        });

        return { comments: newComments, totalRecords: data.totalComments, totalThreads };
    }

    ///
    private deleteComment(item: CommentListItemDto) {
        api.deleteComment(item.commentId)
            .then((v) => {
                this.setState({
                    ...this.state,
                    ...this.resetState(),
                    ...this.recalculateStateAfterDelete(v),
                });

                if (this.props.onUpdateCommentCounter) this.props.onUpdateCommentCounter(v.totalComments);
                this.props.snackbar.showMessage(this.props.t("Views.Publication.Components.CommentBox.DeleteCommentSuccess"), "success");
            })
            .catch((error) => {
                this.setState({ lastError: error, formCycle: RequestLifeCycle.PostFailed });
            });
    }

    ///
    private postLike(commentId: string, currentLikeOption: PublicationLikeOption, newLikeOption: PublicationLikeOption) {
        api.postCommentLike({
            objectId: commentId,
            likeOption: currentLikeOption == null
                ? newLikeOption
                : currentLikeOption == newLikeOption
                    ? PublicationLikeOption.Neutral
                    : currentLikeOption * -1
        })
            .then((result) => {
                this.setState({
                    ...this.state,
                    ...this.resetState(),
                    ...{ comments: this.updateComment(commentId, { interaction: result }) }
                });
            })
            .catch((error) => {
                this.setState({ lastError: error, formCycle: RequestLifeCycle.PostFailed });
            });
    }

    ///
    private handleResponseClick(commentId: string) {
        this.setState({ responding: true, comments: this.updateComment(commentId, { responding: true }) });
    }

    ///
    private handleOpenMenu(e: React.MouseEvent<HTMLElement>, item: CommentListItemDto) {
        const { interaction: { actions } } = item;
        const actionMenu: Array<any> = [];

        if (actions.canReportAbuse) actionMenu.push(<MenuItem key="reportAbuse" onClick={() => this.handleReportAbuse(item)}>{this.props.t("Common.MenuAction.ReportAbuse")}</MenuItem>);

        if (actions.canEdit) actionMenu.push(<MenuItem key="edit" onClick={() => { this.handleEdit(item); }}>{this.props.t("Common.MenuAction.Edit")}</MenuItem>);

        if (actions.canDelete && !item.deleted) {
            if (actionMenu.length > 0) actionMenu.push(<Divider key="dividerDelete" />);
            actionMenu.push(<MenuItem key="delete" onClick={() => this.handleDelete(item)}><MuiColor variant="error">{this.props.t("Common.MenuAction.Delete")}</MuiColor></MenuItem>);
        }

        this.setState({
            commentMenuAnchorEl: e.currentTarget,
            commentActionMenu: actionMenu
        });
    }

    ///
    private handleCloseMenu() {
        this.setState({ commentMenuAnchorEl: null });
    }

    private handleReportAbuse(item: CommentListItemDto): void {
        this.setState({
            reportingAbuse: item,
            commentMenuAnchorEl: null
        });
    }

    ///
    private handleEdit(item: CommentListItemDto): void {
        this.setState({
            comments: this.updateComment(item.commentId, { editing: true }),
            newCommentText: item.message,
            responding: true,
            commentMenuAnchorEl: null
        });
    }

    ///
    private handleDelete(item: CommentListItemDto): void {
        this.setState({
            commentToDelete: item,
            commentMenuAnchorEl: null
        });
    }

    ///
    private handleCancelEdit(commentId: string): void {
        if (commentId != null) {
            this.setState({ ...this.state, ...this.resetState(), ...{ comments: this.updateComment(commentId, { responding: false, editing: false }) } });
        }
        else {
            this.setState({ ...this.state, ...this.resetState() });
        }
    }

    ///
    private renderMenu(item: CommentListItemDto): JSX.Element {
        const { interaction: { actions } } = item;
        const { commentMenuAnchorEl, commentActionMenu, readOnly } = this.state;

        if (readOnly || item.deleted || (!actions.canDelete && !actions.canEdit && !actions.canReportAbuse))
            return null;

        return (
            <>
                <IconButtonOverflowV
                    size="small"
                    onClick={(e) => { this.handleOpenMenu(e, item); }}
                />
                <Menu
                    id="simple-menu"
                    anchorEl={commentMenuAnchorEl}
                    open={commentMenuAnchorEl != null}
                    onClose={() => { this.handleCloseMenu(); }}
                >
                    {commentActionMenu}
                </Menu>
            </>
        );
    }

    ///
    private renderPicture(item: CommentListItemDto, parentId: string): JSX.Element {
        const { classes } = this.props;

        const url = item == null || parentId != null ? Session.thumbnailUrl : item.publisher.thumbnailUrl;

        return (
            <div className={classes.itemPicture}>
                <Avatar src={url} onClick={() => HtmlUtils.openUrlInNewWindow(RoutePaths.UserProfileViewer.replace(":id?", item.publisher.id))} />
            </div>
        );
    }

    ///
    private renderMessage(item: CommentListItemDto): JSX.Element {
        const relativeTime = Formaters.relativeTime(item.publishDate);
        const edited = item.publishDate.getTime() != item.lastUpdateDate.getTime()
            ? this.props.t("Views.Publication.Components.CommentBox.EditedText")
            : null;

        return (
            <div>
                <div>
                    <small><b><UserFullProfileLink user={item.publisher} /></b>&nbsp;<MuiMuted>{relativeTime} {edited}</MuiMuted></small>
                </div>
                <div className={item.commentId == this.hightlightCommentId && this.loadCount == 1 ? this.props.classes.highlightComment : null}>
                    {
                        item.replyPublisher != null
                            ? <MuiMuted><b><FontAwesomeIcon icon={faReply} />&nbsp;<UserFullProfileLink user={item.replyPublisher} />:</b>&nbsp;</MuiMuted>
                            : null
                    }
                    {
                        item.deleted && item.abuseReported === false
                            ? <MuiDanger showIcon>&nbsp;{this.props.t("Views.Publication.Components.CommentBox.DeletedCommentMessage", { name: UsernameResolver(item.deleter, true) })}</MuiDanger>
                            : item.deleted && item.abuseReported === true
                                ? <MuiDanger showIcon>&nbsp;{this.props.t("Views.Publication.Components.CommentBox.CommentBlockedMessage")}</MuiDanger>
                                : <span dangerouslySetInnerHTML={{ __html: HtmlUtils.textToHtml(item.message) }}></span>
                    }
                </div>
            </div>
        );
    }

    ///
    private renderLoadMore(commentId: string): JSX.Element {

        if (!this.showingAllRecords) return null;

        const comment = this.state.comments.find(p => p.commentId == commentId);
        var totalLoaded = this.state.comments.filter(p => p.parentId == commentId).length;

        return totalLoaded > 0 && totalLoaded < comment.answers && comment.parentId != null
            ? (
                <MuiRegularButton
                    onClick={
                        () => {
                            this.loadComments(commentId, totalLoaded);
                        }
                    }
                >
                    <span>{this.props.t("Common.Literals.LoadMore")}</span>
                </MuiRegularButton>
            )
            : null;
    }

    ///
    private renderGlobalLoadMore() {

        let total = 0;
        var nextCount = 0;
        if (this.showingAllRecords) {
            total = this.state.comments.filter(p => p.parentId == null).length;
            if (this.state.totalThreads > total)
                nextCount = this.state.totalThreads - total;
        }
        else {
            total = this.state.comments.length;
            if (this.state.totalRecords > total)
                nextCount = this.state.totalRecords - total;
        }

        return nextCount > 0
            ? (
                <MuiRegularButton
                    onClick={
                        () => {
                            this.loadComments(null, total);
                        }
                    }
                >
                    <span>{this.props.t("Views.Publication.Components.CommentBox.TotalComments", { count: nextCount })}</span>
                </MuiRegularButton>
            )
            : null;
    }

    ///
    private renderSocial(item: CommentListItemDto): JSX.Element {
        const userId = Session.user.id;
        const { readOnly } = this.state;
        var total = this.state.comments.filter(p => p.parentId == item.commentId).length;

        return (
            <Grid container alignItems="center">
                <Grid item>
                    {
                        item.deleted
                            ? (
                                <>
                                    <Typography
                                        style={{ display: "inline-block" }}
                                        variant="button"
                                        title={this.props.t("Common.Feed.Actions.ButtonLikeTitle")}
                                    >
                                        <MuiMuted>
                                            <IconThumbUp />&nbsp;
                                            {`${item.interaction.likes > 0 ? "+" : ""}${item.interaction.likes}`}
                                        </MuiMuted>
                                    </Typography>
                                </>
                            )
                            : (
                                <>

                                    <MuiRegularButton
                                        simple
                                        iconSize="small"
                                        title={this.props.t("Common.Feed.Actions.ButtonLikeTitle")}
                                        color={item.interaction.liked === PublicationLikeOption.Like ? "pressed" : "muted"}
                                        disabled={item.publisher.id == userId || readOnly}
                                        onClick={() => { this.postLike(item.commentId, item.interaction.liked, PublicationLikeOption.Like); }}
                                    >
                                        <FontAwesomeIcon fixedWidth icon={faThumbsUp} />
                                    </MuiRegularButton>

                                    <Typography
                                        style={{ display: "inline-block" }}
                                        variant="button"
                                        title={this.props.t("Common.Feed.Actions.RateTitle")}
                                    >
                                        <small><MuiMuted>
                                            {`${item.interaction.likes > 0 ? "+" : ""}${item.interaction.likes}`}
                                        </MuiMuted></small>
                                    </Typography>


                                    <MuiRegularButton
                                        simple
                                        iconSize="small"
                                        title={this.props.t("Common.Feed.Actions.ButtonDislikeTitle")}
                                        color={item.interaction.liked === PublicationLikeOption.Dislike ? "pressed" : "muted"}
                                        disabled={item.publisher.id == userId || readOnly}
                                        onClick={() => { this.postLike(item.commentId, item.interaction.liked, PublicationLikeOption.Dislike); }}
                                    >
                                        <FontAwesomeIcon fixedWidth icon={faThumbsDown} />
                                    </MuiRegularButton>

                                    {
                                        !this.state.responding && item.publisher.id != Session.user.id && !readOnly &&
                                        <MuiRegularButton
                                            color={"muted"}
                                            onClick={
                                                () => { this.handleResponseClick(item.commentId); }}
                                        >
                                            <small>
                                                {
                                                    item.parentId == null
                                                        ? (<span>{this.props.t("Common.Feed.Actions.ButtonAnswerText")}</span>)
                                                        : (<span>{this.props.t("Common.Feed.Actions.ButtonAnswerToText", { name: LibUtils.firstWord(item.publisher.name) })}</span>)
                                                }
                                            </small>
                                        </MuiRegularButton>
                                    }
                                </>
                            )
                    }
                </Grid>
                <Grid item>
                    {
                        item.answers > 0 && item.parentId == null && total == 0 && !this.state.responding
                            ? (
                                <MuiRegularButton
                                    link
                                    onClick={
                                        () => {
                                            this.loadComments(item.commentId, 0);
                                        }
                                    }
                                >
                                    <small>
                                        <span>{this.props.t("Views.Publication.Components.CommentBox.ViewAnswersMessage", { count: item.answers })} <FontAwesomeIcon icon={faCaretDown} /></span>
                                    </small>
                                </MuiRegularButton>
                            )
                            : null
                    }

                    {
                        item.answers > 0 && total > 0 && !this.state.responding && this.showingAllRecords
                            ? (
                                <MuiRegularButton
                                    link
                                    onClick={
                                        () => {
                                            this.setState({ comments: this.state.comments.filter(p => p.parentId != item.commentId) });
                                        }
                                    }
                                >
                                    <small>
                                        <span>{this.props.t("Views.Publication.Components.CommentBox.ButtonHideAnswers")}</span>
                                    </small>
                                </MuiRegularButton>
                            )
                            : null
                    }
                </Grid>
            </Grid>
        );
    }

    ///
    private renderFooter(item: CommentListItemDto): JSX.Element {
        return (
            <Grid container alignItems="center">
                <Grid item xs className={this.props.classes.itemSeparator}>{this.renderSocial(item)}</Grid>
                <Grid item>{this.renderMenu(item)}</Grid>
            </Grid>
        );
    }

    ///
    private renderResponse(item: CommentListItemDto, addParams: { parentId?: string, replyCommentId?: string; }): JSX.Element {

        if (this.state.readOnly) return null;

        const { publicationId, classes, autoFocus } = this.props;
        const { parentId = null, replyCommentId = null } = addParams;
        return (
            <div
                key={"reponse-" + !item ? "" : item.commentId}
                className={classes.itemOuter}
            >
                {this.renderPicture(item, parentId)}

                <div className={classes.itemContent}>

                    <TextFieldCounter
                        id="commentTextBox"
                        multiline
                        fullWidth
                        maxLength={1500}
                        autoFocus={autoFocus}
                        placeholder={
                            replyCommentId == null
                                ? this.props.t("Views.Publication.Components.CommentBox.ReplyCommentPlaceholder")
                                : this.props.t("Views.Publication.Components.CommentBox.ReplyCommentToPlaceholder", { name: item.publisher.name })
                        }
                        value={this.state.newCommentText}
                        onChange={(v) => { this.setState({ newCommentText: v }); }}
                    />

                    {
                        this.state.newCommentText.length > 0 || item != null
                            ? (
                                <div className={classes.itemEditButtons}>
                                    <ButtonCancel
                                        onClick={() => { this.handleCancelEdit(item == null ? null : item.commentId); }}
                                    />

                                    <MuiRegularButton
                                        color="success"
                                        onClick={
                                            () => {
                                                item != null && item.editing
                                                    ? this.postUpdateComment(item.commentId, this.state.newCommentText)
                                                    : this.postNewComment(publicationId, parentId, replyCommentId, this.state.newCommentText);
                                            }
                                        }
                                    >
                                        <span>{
                                            (item != null && item.editing)
                                                ? this.props.t("Views.Publication.Components.CommentBox.ButtonUpdate")
                                                : this.props.t("Views.Publication.Components.CommentBox.ButtonPost")
                                        }
                                        </span>
                                    </MuiRegularButton>
                                </div>
                            )
                            : null
                    }
                </div>
            </div>
        );
    }

    ///
    private renderComment(parentId: string): JSX.Element[] {
        const { classes } = this.props;

        var comments = parentId == null
            ? this.state.comments.filter(p => p.parentId == parentId)
            : this.state.comments.filter(p => p.parentId == parentId).sort((a, b) => a.publishDate.getTime() - b.publishDate.getTime());

        return comments.map((item, index) => {

            var total = this.state.comments.filter(p => p.parentId == item.commentId).length;

            return (
                <Fragment key={item.commentId}>
                    {
                        <>
                            <div className={classes.itemOuter} >

                                {/* 1a Coluna */}
                                {
                                    item.editing ? null : this.renderPicture(item, null)}

                                {/* 2a Coluna */}
                                <div className={classes.itemContent}>

                                    {/* Respondendo um item de Primeiro Nível */}
                                    {item.editing ? this.renderResponse(item, {}) : this.renderMessage(item)}

                                    <div className={classes.itemFooter}>

                                        {item.editing ? null : this.renderFooter(item)}

                                        {/* Respondendo um item de Segundo Nível ou maior */}
                                        {item.responding && parentId == null ? this.renderResponse(item, { parentId: item.commentId }) : null}

                                        {/* Comentários */}
                                        {total > 0 ? this.renderComment(item.commentId) : null}

                                        {/* Botão para carregar mais items do Segundo Nível */}
                                        {this.renderLoadMore(item.commentId)}

                                        {item.loading ? <SpinnerIndicator /> : null}

                                    </div>

                                </div>
                            </div>

                            {/* Respondendo em Segundo Nível ou maior */}
                            {item.responding && parentId != null ? this.renderResponse(item, { parentId, replyCommentId: item.commentId }) : null}
                        </>
                    }
                </Fragment>
            );
        });
    }

    ///
    private renderDeleteConfirmation(): JSX.Element {

        if (this.state.commentToDelete == null)
            return null;

        return (
            <MuiConfirmation
                title={this.props.t("Views.Publication.Components.CommentBox.ConfirmationDeleteTitle")}
                message={this.props.t("Views.Publication.Components.CommentBox.ConfirmationDeleteMessage")}
                onClose={
                    (result) => {
                        if (result === true) this.deleteComment(this.state.commentToDelete);
                        else this.setState({ commentToDelete: null });
                    }
                }
            />
        );
    }

    ///
    private renderReportAbuse(): JSX.Element {
        if (this.state.reportingAbuse == null) return null;

        return (
            <AbuseReportCommentDrawer
                commentId={this.state.reportingAbuse.commentId}
                onClose={(result) => {
                    if (result) {
                        this.setState({
                            ...this.state,
                            ...this.resetState(),
                            ...{ comments: this.updateComment(this.state.reportingAbuse.commentId, { interaction: result }) }
                        });
                    }
                    else {
                        this.setState({
                            ...this.state,
                            ...this.resetState(),
                        });
                    }
                }}
            />
        );
    }

    ///
    private handleUpdateFilter = (searchText: string, advFilters: AdvFilterResult[], pressedEnter: boolean) => {

        var newFilter: Filter = null;

        if (searchText.length > 0 || advFilters.length > 0) {

            const authors = [];
            if (advFilters.findIndex(x => x.keyword == CmdComments) > -1) authors.push(Session.user.id);
            const a = advFilters.find(x => x.keyword == CmdAuthor); if (a != null) authors.push(a.value);

            var dts = advFilters.find(x => x.keyword == CmdStartDate);
            var dte = advFilters.find(x => x.keyword == CmdEndDate);

            newFilter = {
                searchText: searchText.length == 0 ? null : searchText,
                startDate: dts ? (dts.value as Date).putStartOfDay() : null,
                endDate: dte ? (dte.value as Date).putEndOfDay() : null,
                authors
            };
        }

        this.setState({ advFilters, filter: newFilter }, () => {
            if (pressedEnter) this.reload();
        });
    };

    ///
    private renderAdvFilter(): JSX.Element {
        return (
            <div style={{ flexGrow: 1 }}>
                <AdvFilter
                    id="advfilter"
                    autoFocus
                    overModal={this.props.overModal}
                    commands={this.commands}
                    placeHolder={this.props.t("Common.Filter.Adv.InputPlaceholder")}
                    title={this.props.t("Common.Filter.Adv.InputTitleEnterToFilter")}
                    selectedCommands={this.state.advFilters}
                    onUpdateSelection={this.handleUpdateFilter} />
            </div>
        );
    }

    ///
    private renderBaseFilter(): JSX.Element {
        const { filter, orderByMenuAnchorEl } = this.state;

        return (
            <>
                <div className={GlobalClassKeys.grow}>
                    <div className={this.showingAllRecords ? null : this.props.classes.filtered}>

                        <IconButtonFilter
                            color={this.showingAllRecords ? "white" : "warning"}
                            onClick={() => { this.setState({ inAdvFilter: true }); }}
                        />

                        <span>{this.props.t("Views.Publication.Components.CommentBox.CommentsCounter", { count: this.state.totalRecords })}</span>

                        {
                            filter &&
                            <MuiRegularButton
                                simple
                                color="inherit"
                                title={this.props.t("Common.Filter.ResetText")}
                                onClick={
                                    () => {
                                        this.setState({ filter: null, advFilters: [] }, () => this.reload());
                                    }
                                }
                            >
                                <FontAwesomeIcon fixedWidth icon={faTimes} />
                            </MuiRegularButton>
                        }
                    </div>
                </div>

                {
                    this.showingAllRecords &&
                    <div>
                        <MuiRegularButton
                            link
                            color="inherit"
                            title={this.props.t("Common.Buttons.EllipsisTitle")}
                            onClick={
                                (e) => {
                                    this.setState({ orderByMenuAnchorEl: e.currentTarget });
                                }
                            }
                        >
                            {this.getCurrentOrderByName()}&nbsp;<FontAwesomeIcon icon={faCaretDown} />
                        </MuiRegularButton>
                        <Menu
                            anchorEl={orderByMenuAnchorEl}
                            open={orderByMenuAnchorEl != null}
                            onClose={
                                () => {
                                    this.setState({ orderByMenuAnchorEl: null });
                                }}
                        >
                            <MenuItem onClick={() => this.setState({ orderBy: CommentListOrderBy.PublishDate }, () => this.reload())}>{this.props.t("Common.Filter.Toolbar.OrderBy.MostRecent")}</MenuItem>
                            <MenuItem onClick={() => this.setState({ orderBy: CommentListOrderBy.Best }, () => this.reload())}>{this.props.t("Common.Filter.Toolbar.OrderBy.BestComments")}</MenuItem>
                        </Menu>
                    </div>
                }
            </>
        );
    }

    ///
    private renderFilterBar(): JSX.Element {

        return (
            <MuiFilterAppBar
                position="static"
            >
                <Toolbar variant="dense" disableGutters>
                    {this.state.inAdvFilter && this.renderAdvFilter()}
                    {!this.state.inAdvFilter && this.renderBaseFilter()}
                </Toolbar>
            </MuiFilterAppBar>
        );
    }


    ///
    public componentDidMount() {
        if (this.state.comments.length == 0) {

            var advFilter: AdvFilterResult[] = [];
            if (this.props.startDate)
                advFilter = advFilterAddCommand(this.commands, advFilter, CmdStartDate, this.props.startDate);
            if (this.props.endDate)
                advFilter = advFilterAddCommand(this.commands, advFilter, CmdEndDate, this.props.endDate);

            this.handleUpdateFilter("", advFilter, true);
        }
    }

    ///
    public render() {
        const { classes } = this.props;

        if (this.state.lastError && this.state.formCycle == RequestLifeCycle.LoadFailed)
            return <RequestErrorReport error={this.state.lastError} />;

        var firstLoading = this.state.formCycle == RequestLifeCycle.Loading && this.state.comments.length == 0;

        console.log('firstLoading');
        console.log(firstLoading);
        console.log('this.state.readOnly');
        console.log(this.state.readOnly);


        return (
            <div>

                {!firstLoading && !this.state.readOnly && this.renderFilterBar()}

                {
                    !firstLoading && this.state.readOnly && this.state.comments.length == 0
                        ? <Alert severity="info">{this.props.t("Views.Publication.Components.CommentBox.EmptyData")}</Alert>
                        : (
                            <div className={classes.containerOuter}>
                                <div className={classes.containerInner}>

                                    <MuiContainer margin="dense">

                                        {!this.state.responding && this.renderResponse(null, {})}

                                        {this.renderComment(null)}

                                        {this.renderGlobalLoadMore()}

                                        {this.state.formCycle == RequestLifeCycle.Loading && <SpinnerIndicator />}

                                        <RequestErrorDialog
                                            open={this.state.formCycle == RequestLifeCycle.PostFailed}
                                            error={this.state.lastError}
                                            onClose={() => this.setState({ lastError: null, formCycle: RequestLifeCycle.None })}
                                        />

                                    </MuiContainer>

                                </div>
                            </div>
                        )
                }

                {this.renderDeleteConfirmation()}

                {this.renderReportAbuse()}
            </div>
        );
    }
}

export default withSnackbar(withTranslation()(withStyles(styles)(CommentBox)));